exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w3m7f{height:100vh;position:fixed;top:0;left:0;right:0;z-index:1150;background-color:hsla(0,0%,100%,.9)}.w3m7f ._3JBZv{margin:50% 32px;padding:8px 8px 24px;text-align:center;background-color:#d9d9d9}.w3m7f ._3JBZv .sBEZt{text-align:right}.w3m7f ._3JBZv .sBEZt span{cursor:pointer}.w3m7f ._3JBZv .sBEZt span img{width:16px;height:16px}.w3m7f ._3JBZv ._3Cm5T{margin-bottom:16px}.w3m7f ._3JBZv ._3Cm5T img{width:80px;height:80px}.w3m7f ._3JBZv ._2sh3j{margin-bottom:16px;padding:0 32px;font-size:20px;font-weight:700}.w3m7f ._3JBZv ._3Yu5g{padding:0 32px}", ""]);

// exports
exports.locals = {
	"obNotificationRoot": "w3m7f",
	"container": "_3JBZv",
	"header": "sBEZt",
	"icon": "_3Cm5T",
	"title": "_2sh3j",
	"message": "_3Yu5g"
};